import {baseStagingConfig} from '../base/staging.config';
import {cbssportsQaConfig} from './qa.config';
import * as extendUtils from '../../../utils/object/extend.utils';
import {PrismConfigOptions} from '../environment-variables.interface';

export const cbssportsStagingConfig: PrismConfigOptions = extendUtils.deepExtend({}, [baseStagingConfig, cbssportsQaConfig, {
  environmentName: 'Cbs Sports Staging Environment',
  ionicEnvName: 'staging',
}]);



// WEBPACK FOOTER //
// ./src/app/environment-variables/cbssports/staging.config.ts